import { Directive } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validators } from "@angular/forms";

@Directive({
    selector: "[PrimaryAndMailingAddressValidator]",
    providers: [{ provide: NG_VALIDATORS, useExisting: PrimaryAndMailingAddressValidatorDirective, multi: true }]
})

export class PrimaryAndMailingAddressValidatorDirective implements Validators {
    validate(control: AbstractControl): ValidationErrors | null {
        if (!!!control) {
            return null;
        }

        let errorMessage : string | null = this.validateAddress(control.value);
        return !!errorMessage ? { 'invalidAddressLength': true, 'message': errorMessage} : null; 
    }

    private validateAddress(addressValue: string) : string {
        const match = addressValue?.match(/^([0-9][^\s]*)?(.*)$/);
       
        const buildingNumber = match?.[1]?.trim() || "";
        const streetAddress = match?.[2]?.trim() || "";

        if (!!buildingNumber && buildingNumber?.length > 10) {
            return 'Street Address building number can not be longer than 10 characters';
        }
        if (!!streetAddress && streetAddress?.length > 40) {
             return 'Street Address can not be longer than 40 characters';
        }

        return null;
    }
}